import { DatePipe, CommonModule } from '@angular/common';
import { AfterContentInit, AfterViewInit, Component, computed, effect, inject, OnInit, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, first, firstValueFrom, lastValueFrom, timer } from 'rxjs';
import { AppTypeEnum } from '../../enums';
import { ApiService } from '../../services/api.service';
import { HeaderComponent } from "../header/header.component";
import { ParamsConstants, StorageConstants } from '../../constants';
import { NavigatorHelper, StorageHelper } from '../../helpers';
import { StockingService } from '../../services/stocking.service';

@Component({
  selector: 'app-layout',
  imports: [RouterModule, DatePipe, MatIconModule, CommonModule, HeaderComponent],
  standalone: true,
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.scss'
})
export class AppLayoutComponent implements OnInit {

  public loading: boolean = true;
  public hasKey: boolean = false;


  public location: string | null = null;
  public validUntil: string | null = null;
  public apiKey: string | null = null;

  public appType: AppTypeEnum | null = null;
  public appTypeEnum = AppTypeEnum;

  public dynSystem: string | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private stockingService: StockingService
  ) {
    effect(() => {
      this.validUntil = ApiService.until();
      this.location = ApiService.location();
      this.apiKey = ApiService.censoredKey();
      this.appType = NavigatorHelper.appType();
    })
    effect(() => {
      this.getDynSystem(StockingService.dynId())
    })
  }

  async ngOnInit() {
    await firstValueFrom(
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        first()
      )
    );
    let current = this.route.root;
    while (current.firstChild) {
      current = current.firstChild;
    }
    let locationCode = current.snapshot.params[ParamsConstants.LOCATION_CODE];
    let apiKey = current.snapshot.params[ParamsConstants.API_KEY];
    
    console.log(apiKey, locationCode);
    console.log(this.router.url)
    if (!apiKey || !locationCode) {
      locationCode = ApiService.locationCode() || StorageHelper.getItem<string>(ParamsConstants.LOCATION_CODE) as string;
      apiKey = ApiService.apiKey() || StorageHelper.getItem(ParamsConstants.API_KEY) as string;
    }
    if (apiKey && locationCode) {
      try {
        const data = await lastValueFrom(this.apiService.testApiKey(apiKey, locationCode));
        const location = await lastValueFrom(this.apiService.checkLocationCode(locationCode));
        console.log(data)
        StorageHelper.setItem(ParamsConstants.LOCATION_CODE, locationCode);
        StorageHelper.setItem(ParamsConstants.API_KEY, apiKey);
        StorageHelper.setItem(StorageConstants.LOCATION, location.name);
        StorageHelper.setItem(StorageConstants.DATE, data.valid_until);
        ApiService.locationCode.set(locationCode);
        ApiService.apiKey.set(apiKey);
        ApiService.location.set(location.name);
        ApiService.until.set(data.valid_until);
        this.hasKey = true;
        this.loading = false;
      } catch (error) {
        console.log(error)
        this.loading = false;
      }
    } else {
      this.loading = false
    }

  }

  private async getDynSystem(dynId: string | null) {
    if (!dynId) {
      this.dynSystem = null;
    } else {
      try {
        const data = await lastValueFrom(this.stockingService.getSystemByDinId(dynId));
        console.log(data)
        this.dynSystem = data.system.name_lang.de;
      } catch (error) {

      }
    }
  }

}
